import { Box, Typography, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { CSSProperties, ReactNode } from 'react';

type PrototypeSectionProps = {
  style?: CSSProperties;
  headerStyle?: CSSProperties;
  actions?: ReactNode;
  title: string;
  children: ReactNode;
  className?: string;
  headerClassName?: string;
};

const useStyles = makeStyles(
  theme => ({
    root: {
      paddingBottom: theme.spacing(2),
      paddingInline: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      // to avoid react flow grab cursor
      cursor: 'default',
    },
    headerContainer: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
      paddingBlock: theme.spacing(1),
    },
    headerTitle: {
      fontWeight: 700,
    },
    content: {
      flex: 1,
    },
  }),
  { name: 'PrototypeSection' },
);

export const PrototypeSection = ({
  title,
  actions,
  style,
  headerStyle,
  children,
  className,
  headerClassName,
}: PrototypeSectionProps) => {
  const classes = useStyles();
  return (
    <Box className={clsx(classes.root, className)} style={style}>
      <Box
        className={clsx(classes.headerContainer, headerClassName)}
        style={headerStyle}
      >
        <Typography className={classes.headerTitle}>{title}</Typography>
        {actions}
      </Box>
      {children}
    </Box>
  );
};
